export default __webpack_public_path__ + "media/8552bc17178c8326f9c2137e24a5d49d675ce1cdb55dca094b7213554ee8da5d.svg";